// assets
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
// icons
const icons = {
    KeyOutlinedIcon,
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const pages = {
    id: 'apiAndServices',
    title: 'APIs and Services',
    type: 'group',
    subscriptionRequired: ['basic','standard','premium','enterprise', 'admin'],
    children: [
        {
            id: 'credentials',
            title: 'Credentials',
            type: 'item',
            url: '/credentials',
            icon: icons.KeyOutlinedIcon,
            target: false,
            showInShopifyApp: true,
        },
    ]
};

export default pages;
